import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { APPLICATION_DETAIL_ENDPOINT, BASEURL_POLYMER, SUB_PATH_BASIC } from '../../utils/api'
import { StageDReviewApplication } from '../../models/classes/stage-d/Review-Application.class'
import config from '../../config'

interface QueryParams {
  application_id: string
  uinfin: string
  singpass_token: string
}

export const stageEGetDocument = createApi({
  reducerPath: 'stageEGetDocument',
  baseQuery: fetchBaseQuery({ baseUrl: BASEURL_POLYMER, 
  prepareHeaders:(headers,{getState})=>{
    headers.set("Access-Control-Request-Method", "GET");
    headers.set("X-Content-Type-Options", "nosniff");
    headers.set("x-api-key", `${config.xApiKey}`);
  }}),
  endpoints: (builder) => ({
    getSubmittedDocuments: builder.query<any, QueryParams>({
      query: (queryParams: QueryParams) => ({
        method: "GET",
        url:`${SUB_PATH_BASIC}${APPLICATION_DETAIL_ENDPOINT}?applicationUuid=${queryParams.application_id}`,
        headers: {
          uinfin: queryParams.uinfin,
          Authorization: `Bearer ${queryParams.singpass_token}`
        },
      }),
      transformResponse:(response: any, meta, arg)=>{
        return response.documents.filter((e:any)=>e.label);
      },
      keepUnusedDataFor:1,
    }),
    
    getReferDocuments: builder.query<any, QueryParams>({
      query: (queryParams: QueryParams) => ({
        method: "GET",
        url:`${SUB_PATH_BASIC}/application/getApplicationUpdate/${queryParams.application_id}`,
        headers: {
          uinfin: queryParams.uinfin,
          Authorization: `Bearer ${queryParams.singpass_token}`
        },
      }),
      transformResponse:(response: any, meta, arg)=>{
          
        let formatted_response = new StageDReviewApplication(response);
        if(formatted_response.stageEProcessFolders){
          formatted_response.stageEProcessFolders();
        }
        if(formatted_response.json){
          
          try{
            return formatted_response.json()?.folders[0]?.comments[0]?.documents ?? [];
          }
          catch(e){
            console.log("STAGE E - REFER ERROR",e);
            return [];
          }
        }
        
        return response;
  
      },
      keepUnusedDataFor:1,
    }),
  }),
  
})

export const { useGetSubmittedDocumentsQuery, useGetReferDocumentsQuery } = stageEGetDocument

